module.exports = __webpack_public_path__ + "img/barcelo-room-2.f2817b45.jpg";